import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PeFormInstanceService } from '@app/api/api-services/pe-form-instance.service';
import { RejectPeSummariesModalComponent } from 'src/app/shared/modals/reject-pe-summaries-modal/reject-pe-summaries-modal.component';
import * as _ from 'lodash';
import { PeFormInstanceDependenciesApiModel } from '@app/api/api-models/pe-features/PeFormInstanceDependenciesApiModel';

@Injectable()
export class RejectPeSummariesModalProxyService {
  constructor(
    private readonly peFormInstanceService: PeFormInstanceService,
    private readonly bsModalService: BsModalService
  ) {}

  public displayRejectionModal(
    formInstanceId: number | number[],
    hasSummariesCallback: Function,
    cancelCallback: Function,
    errorCallback: Function,
    noSummariesCallback: Function,
    mode: 'delete' | 'reject' | 'submit'
  ): void {
    const formInstanceIds = Array.isArray(formInstanceId) ? formInstanceId : [formInstanceId];
    const subscribeParameters = {
      next: this.processSummaries.bind(this, hasSummariesCallback, cancelCallback, noSummariesCallback, mode),
      error: () => {
        errorCallback();
        cancelCallback();
      }
    };

    this.peFormInstanceService.getSummariesByIdsMultiple(formInstanceIds).subscribe(subscribeParameters);
  }

  private processSummaries(
    hasSummariesCallback: Function,
    cancelCallback: Function,
    noSummariesCallback: Function,
    mode: 'delete' | 'reject' | 'submit',
    summaries: PeFormInstanceDependenciesApiModel | Array<PeFormInstanceDependenciesApiModel>
  ): void {
    const summariesAsArray = [summaries].flat();
    const bindedForms = summariesAsArray.filter((x) => x.BindedForms.length > 0).map((x) => x.BindedForms);
    const flattenSummaries = _.uniqBy(_.flatten(bindedForms), 'id');
    if (flattenSummaries.length === 0) {
      noSummariesCallback();
      return;
    }

    const initialState = {
      confirm: hasSummariesCallback,
      reject: cancelCallback,
      mode: mode,
      summaryFormInstances: flattenSummaries
    };

    this.bsModalService.show(RejectPeSummariesModalComponent, {
      initialState,
      backdrop: 'static'
    });
  }
}
